// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"l4-z","dimensionLabel":"m4-z","styleChooserControlWrapper":"n4-z","styleChooserControl":"o4-z","disabled":"p4-z","giftCard":"q4-z","styleChooserText":"r4-z"};